"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BRAND_CHAT_MAX_MESSAGE_LENGTH = exports.BRAND_CHAT_MAX_MESSAGES = void 0;
exports.BRAND_CHAT_MAX_MESSAGES = 40;
exports.BRAND_CHAT_MAX_MESSAGE_LENGTH = 1000;
